import { appRoutes } from "config/AppRoutesConfig";
import axiosBase, { uploadBaseUrl } from "./base";
import helperBase from "./helperBase";
import { SearchRecord, SearchSource } from "./siteSearchModel";

const documentDestination = (record: SearchRecord, fallback: string): string => {
  const file = record.attributes.documents?.data[0]?.attributes.attached_document?.data?.attributes.url;
  try {
    const destination = record.attributes.doc_link?.trim() || (file ? new URL(file, uploadBaseUrl).href : "");
    const url = new URL(destination);
    if (["http:", "https:"].includes(url.protocol)) return url.href;
  } catch { /* Keep records without usable documents linked to their existing section. */ }
  return fallback;
};

const documentsPopulate = { "populate[documents][populate]": "attached_document" };

export const siteSearchSources: SearchSource[] = [
  {
    endpoint: "news-articles", client: axiosBase.base, fields: ["title", "content", "teaser"],
    extraFields: ["is_emergency"], populate: { "populate[news_category_ids][fields][0]": "title" },
    categoryKey: "articles",
    destination: (record) => (record.attributes.is_emergency
      ? appRoutes.emergencyCommunication
      : record.attributes.news_category_ids?.data.some((category) => category.id === 2)
        ? appRoutes.newsAndPartnersDetails : appRoutes.officialsDetails) + record.id,
  },
  {
    endpoint: "events", client: axiosBase.base, fields: ["title", "content", "city", "address", "partener"],
    categoryKey: "events", destination: (record) => appRoutes.eventDetails + record.id,
  },
  {
    endpoint: "projects", client: axiosBase.base, fields: ["title", "content"],
    categoryKey: "projects", destination: (record) => appRoutes.projectDetails + record.id,
  },
  {
    endpoint: "partners", client: axiosBase.base, fields: ["title", "content"], extraFields: ["type"],
    categoryKey: "partners", destination: (record) => `${appRoutes.partners}?${new URLSearchParams({
      type: record.attributes.type ?? "national", q: record.attributes.title ?? "",
    })}`,
  },
  {
    endpoint: "legislations", client: axiosBase.base, fields: ["title"], extraFields: ["doc_link"],
    categoryKey: "legislation", destination: (record) => documentDestination(record, appRoutes.legislationDetails),
  },
  {
    endpoint: "orders", client: axiosBase.base, fields: ["title"], populate: documentsPopulate,
    categoryKey: "orders", destination: (record) => documentDestination(record, appRoutes.legislationOrders),
  },
  {
    endpoint: "decisions", client: axiosBase.base, fields: ["title"], populate: documentsPopulate,
    categoryKey: "decisions", destination: (record) => documentDestination(record, appRoutes.legislationDecisions),
  },
  {
    endpoint: "consultations", client: axiosBase.base, fields: ["title"], populate: documentsPopulate,
    categoryKey: "consultations", destination: (record) => documentDestination(record, appRoutes.legislationConsults),
  },
  {
    endpoint: "campaigns", client: helperBase.base, fields: ["title", "content"], localized: true,
    categoryKey: "campaigns", destination: (record) => appRoutes.campaignsDetails + record.id,
  },
];
